document.addEventListener('DOMContentLoaded', function () {
  const detailsElements = document.querySelectorAll('.section-header details');
  const stickyHeader = document.querySelector('sticky-header');
  const sectionHeader = document.querySelector('.section-header');
  const modalOverlay = document.querySelector('.gradient-background');

  function updateHeaderState() {
    const anyDetailsOpen = Array.from(detailsElements).some((details) =>
      details.hasAttribute('open')
    );

    if (anyDetailsOpen) {
      modalOverlay.classList.add('active');
      // apply for desktop only
      if (window.innerWidth > 990) {
        stickyHeader.setAttribute('active', 'true');
        sectionHeader.style.mixBlendMode = 'normal';
        stickyHeader.style.backgroundColor = '#fff';
        stickyHeader.style.color = '#000';
      }
    } else {
      modalOverlay.classList.remove('active');
      stickyHeader.removeAttribute('active');
      sectionHeader.removeAttribute('style');
      stickyHeader.removeAttribute('style');
    }
  }

  detailsElements.forEach((details) => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'open'
        ) {
          updateHeaderState();
        }
      });
    });

    observer.observe(details, { attributes: true });
  });

  // Initial check
  updateHeaderState();
});
